import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** features_grid — feature cards with optional images for alternating layouts. */
export function renderFeaturesGrid(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const items = list(section.fields, 'items')
    .map((item, index) => {
      const title = itemStr(item, 'title');
      const description = itemStr(item, 'description');
      const imageUrl = itemStr(item, 'image_url');
      if (!title && !description && !imageUrl) return '';
      const itemPath = `/items/${index}`;
      const lines = [`    <article class="ve-features-grid__item"${editAttr(section, itemPath)}>`];
      if (imageUrl) {
        const imagePath = `/items/${index}/image_url`;
        lines.push(
          `      <img class="ve-features-grid__image" src="${safeUrl(imageUrl)}" alt=""${editAttr(section, imagePath)}>`,
        );
      }
      if (title) lines.push(`      <h3 class="ve-features-grid__title">${escapeHtml(title)}</h3>`);
      if (description) lines.push(`      <p class="ve-features-grid__description">${escapeHtml(description)}</p>`);
      lines.push('    </article>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'features-grid', heading, label),
    itemCollection(section, 'div', 've-features-grid__items', '/items', items),
    '</section>',
  ];
  return parts.join('\n');
}
